<template>
    <div class="moduleAppAddEdit">
         <div class="top">
          <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
          <el-button size="medium" type="primary" @click="onsave">保存</el-button>
        </div>
        <div class="content">
            <div style="width: 810px;padding-top:20px;margin: 0 auto;">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="应用Logo" prop="logo">
                        <uploader ref="coverUploader" pathPrefix="moduleApp" openDelete :extList="['bmp', 'png', 'jpg', 'jpeg', 'gif']" showResult="image" showMode="button" v-model="logo" :multiple="false"></uploader>
                    </el-form-item>
                    <el-form-item label="应用名称" prop="name">
                        <el-input v-model="formData.name" :maxlength="20" placeholder="请输入应用名称"></el-input>
                    </el-form-item>
                    <el-form-item label="应用编码" prop="code">
                        <el-input v-if="!id" v-model="formData.code" :maxlength="10" placeholder="请输入应用编码"></el-input>
                        <span v-else>{{formData.code}}</span>
                        
                    </el-form-item>
                    <el-form-item label="所属平台" prop="systemType">
                        <el-radio-group v-model="formData.systemType">
                            <el-radio :label="2">微校+</el-radio>
                            <el-radio :label="3">成长乐园</el-radio>
                            <el-radio :label="1">通用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-show="formData.systemType != 3" label="适用学校" prop="schoolType">
                        <el-radio-group v-model="formData.schoolType">
                            <el-radio :label="12">通用</el-radio>
                            <el-radio :label="1">幼儿园</el-radio>
                            <el-radio :label="2">中小学</el-radio>
                            <el-radio :label="5">教育局</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="应用类型" prop="isIntegrate">
                        <el-radio-group v-model="formData.isIntegrate">
                            <el-radio :label="1">系统应用</el-radio>
                            <el-radio :label="2">集成应用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="使用分类" prop="moduleType">
                        <el-select v-model.trim="formData.moduleType" placeholder="请选择">
                            <el-option v-for="item in moduleTypeList" :key="item.code" :label="item.value"
                                       :value="parseInt(item.code)">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <div v-if="formData.isIntegrate == 1">
                        <el-form-item label="统计代号" prop="statisticsCode">
                            <el-input :maxlength="8" v-model="formData.statisticsCode" placeholder="模块统计需要"></el-input>
                        </el-form-item>
                    </div>
                    <div v-if="formData.isIntegrate == 2">
                        <el-form-item label="验证域名" prop="domainName">
                            <el-input v-model="formData.domainName"></el-input>
                        </el-form-item>
                        <el-form-item label="授信IP" prop="ip">
                            <el-input v-model="formData.ip"></el-input>
                        </el-form-item>
                        <el-form-item label="敏感信息" prop="sendSensitiveInfo">
                            <el-switch :active-value="1" :inactive-value="2" v-model="formData.sendSensitiveInfo"></el-switch>&nbsp;&nbsp;包含应用敏感字段
                        </el-form-item>
                    </div>
                    <el-form-item label="应用介绍" prop="profile">
                        <el-input v-model="formData.profile" type="textarea" :rows="4"></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';
    import Uploader from "@/components/Uploader/WebUploader";
    import {queryModuleTypeFromDict, insertModule, updateModule, queryModule} from '@/api/moduleApp';

    export default {
        name: "moduleAppAddEdit",
        components: {BackTool, Uploader},
        data() {
            const validateCode = (rule, value, callback) => {
                value = `${value}`.trim();
                if (value === '') {
                    callback(new Error('应用编码不能为空'));
                } else if(!/^\d+$/.test(value)) {
                    callback(new Error('请输入数字'));
                } else {
                    callback();
                }
            };
            const validateIp = (rule, value, callback) => {

                if(this.formData.isIntegrate == 2) {
                    value = `${value}`.trim();
                    if (value === '') {
                        callback(new Error('授信ip不能为空'));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            };
            const validateLogo = (rule, value, callback) => {
                if (this.logo.length  === 0) {
                    callback(new Error('请上传logo'));
                } else {
                    callback();
                }
            };
            const validateStatisticsCode = (rule, value, callback) => {
                value = `${value}`.trim();

                if (value === '') {
                    callback();
                } else if(!/^\d+$/.test(value)) {
                    callback(new Error('请输入数字'));
                } else {
                    callback();
                }
            };
            return {
                isEdit: !!this.$route.query.id,
                id: this.$route.query.id,
                formData: {
                    code: '',
                    domainName: '',
                    ip: '',
                    isIntegrate: 1,
                    logoUrl: '',
                    moduleType: '',
                    name: '',
                    profile: '',
                    schoolType: 12,
                    sendSensitiveInfo: 2,
                    statisticsCode: '',
                    systemType: 2
                },
                rules: {
                    logo: [
                        {required: true, validator: validateLogo}
                    ],
                    name: [
                        { required: true, message: '请输入应用名称', trigger: 'blur' },
                    ],
                    code: [
                        { required: true, validator: validateCode },
                    ],
                    systemType: [
                        { required: true, trigger: 'blur' },
                    ],
                    schoolType: [
                        { required: true, trigger: 'blur' },
                    ],
                    isIntegrate: [
                        { required: true, trigger: 'blur' },
                    ],
                    moduleType: [
                        { required: true, trigger: 'blur', message: '请选择使用分类' },
                    ],
                    ip: [
                        { required: true, validator: validateIp},
                    ],
                    statisticsCode: [
                        { required: true, validator: validateStatisticsCode},
                    ],
                },
                logo: [],
                moduleTypeList: [],

            }
        },
        created() {
            queryModuleTypeFromDict()
                .then(data => {
                    this.moduleTypeList = data;
                    if(data && data.length !== 0 && !this.isEdit) {
                        this.formData.moduleType = parseInt(data[0].code);
                    }
                });
            if(this.isEdit) {
                queryModule({
                    id: this.id
                })
                    .then(data => {
                        data.profile = data.profile || '';
                        this.formData = data;
                        this.logo = [{
                            fileUrl: data.logoUrl
                        }]
                    })
            }
        },
        methods: {
            onsave() {
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        const args = {
                            code: this.formData.code,
                            domainName: this.formData.isIntegrate == 2 ? this.formData.domainName : '',
                            ip: this.formData.isIntegrate == 2 ? this.formData.ip : '',
                            isIntegrate: this.formData.isIntegrate,
                            logoUrl: this.logo[0].fileUrl,
                            moduleType: this.formData.moduleType,
                            name: this.formData.name,
                            profile: this.formData.profile,
                            schoolType: this.formData.systemType != 3 ? this.formData.schoolType : 1,
                            sendSensitiveInfo: this.formData.sendSensitiveInfo,
                            statisticsCode: this.formData.isIntegrate == 1 ? this.formData.statisticsCode : '',
                            systemType: this.formData.systemType
                        };
                        new Promise(resolve => {
                            if(this.isEdit) {
                                args.id = this.id;
                                updateModule(args).then(resolve)
                            } else {
                                insertModule(args).then(resolve)
                            }
                        })
                            .then(() => {
                                this.$message.success(`${this.isEdit ? '编辑' : '新增'}成功`);
                                window.setTimeout(() => {
                                    this.$router.back();
                                }, 500);
                            })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
 .moduleAppAddEdit{
     padding:12px;
       .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
 }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/moduleApp/moduleAppAddEdit.vue